import React from 'react';
import { AlertTriangle } from 'lucide-react';
import OverlayModal from './OverlayModal';
import Button from '../Button';
import { ConfirmActions, ConfirmHead, ConfirmIcon, OverlayMessage } from './ui.styles';

export default function ConfirmModal({
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  loading = false,
  danger = true,
  onConfirm,
  onClose,
}) {
  return (
    <OverlayModal onClose={onClose} width={440} noHead placement="center">
      <ConfirmHead>
        <ConfirmIcon $danger={danger}>
          <AlertTriangle size={16} />
        </ConfirmIcon>
        <h3>{title}</h3>
      </ConfirmHead>
      <OverlayMessage>{message}</OverlayMessage>
      <ConfirmActions>
        <Button type="button" variant="secondary-outline" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button type="button" variant={danger ? 'danger' : undefined} loader={loading} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </ConfirmActions>
    </OverlayModal>
  );
}
